import {IOS, UAParser} from 'ua-parser-js';

type TGetBrowserName = () => string | undefined;
type TGetOS = () => IOS;
type TGetOSShortName = () => string | undefined;
type TGetDeviceType = () => string | undefined;

const getDeviceType: TGetDeviceType = () => {
    const uaParser = new UAParser();

    return uaParser.getDevice()?.type;
};

const getBrowserName: TGetBrowserName = () => {
    const uaParser = new UAParser();

    return uaParser.getBrowser().name;
};

const getOS: TGetOS = () => {
    const uaParser = new UAParser();

    return uaParser.getOS();
};

const getOSShortName: TGetOSShortName = () => {
    const {name} = getOS();

    return name?.toLowerCase().substr(0, 3);
};

// For testing purposes
if (process.env.NODE_ENV !== 'production') {
    (window as any).UAParser = UAParser;
}

export default {
    getDeviceType,
    getBrowserName,
    getOS,
    getOSShortName,
};
